import axios from "axios";
import Cookies from "js-cookie";
import { FIRMFLOWURL } from "../url";

const getApiErrorMessage = (error) =>
  error?.response?.data?.message ||
  error?.response?.data?.Message ||
  error?.message ||
  "Something went wrong";

export const addServiceWithJobs = (serviceWithJobs) => {
  return new Promise(async (resolve) => {
    try {
      const token = Cookies.get("Bearer");
      const response = await axios.post(
        `${FIRMFLOWURL}api/Service/create`,
        {
          ...serviceWithJobs,
        },
        {
          headers: { Authorization: token },
        }
      );
      resolve({ ...response, success: true });
    } catch (err) {
      console.log(err);
      if (err.message.includes(401)) {
        Cookies.remove("Bearer");
        window.location.replace("/");
        return;
      }
      const message = getApiErrorMessage(err);
      resolve({
        success: false,
        message,
        data: {
          success: false,
          message,
        },
      });
    }
  });
};
